export default {
	themes: {
		light: '浅色',
		dark: '深色'
	}
};
